import { useEffect, useState } from "react";
import Joi from "joi-browser";

export default useDefaultEndForm;

export const defaultEndFormSchema = {
  name: Joi.string().required().label("Name"),
  description: Joi.string().allow(null, "").label("Description"),
  completionStatus: Joi.string().required().label("Completion Status"),
};

export const getDefaultEndConfigureData = (endAction) => {
  return {
    name: endAction.name,
    description: endAction.description,
    completionStatus: endAction.completionStatus,
  };
};

function useDefaultEndForm(endAction, validationErrors = {}) {
  const [formState, setFormState] = useState(() =>
    getDefaultEndConfigureData(endAction),
  );

  const [errors, setErrors] = useState(validationErrors);

  useEffect(() => {
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  const updateFormState = (field, value) => {
    setFormState((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: undefined }));
  };

  const validate = () => {
    const schema = Joi.object(defaultEndFormSchema);
    const { error } = schema.validate(formState, { abortEarly: false });

    if (!error) {
      setErrors({});
      return true;
    }

    const fieldErrors = {};
    error.details.forEach((detail) => {
      fieldErrors[detail.path[0]] = detail.message;
    });

    setErrors(fieldErrors);
    return false;
  };

  return { formState, errors, updateFormState, validate };
}
